
import Vue from "vue";
import { FrequencyDocumentEditState } from "../../utils/frequency-document-edit-state";
import AppFinish from "./FrequencyDocumentSaveModalFinish.vue";
import AppFreqeuncySettingEdit from "./FrequencySettingsEdit.vue";
import AppMailSettings from "./FrequencySettingsMail.vue";
import AppFrequencySettingsEditSelectFrequencyType from "./FrequencySettingsEditSelectFrequencyType.vue";
import AppPreviewDates from "./FrequencySettingsPreviewDates.vue";

export default Vue.extend({
	data() {
		return {
			step: 1,
		};
	},
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	computed: {
		backButtonText():string {
			if (this.step == 1) {
				return this.$ct("common.cancel").toString();
			}
			return this.$ct("common.back").toString();
		},
		nextButtonText():string {
			if (this.step == 5) {
				return this.$ct("common.save").toString();
			}
			return this.$ct("common.next").toString();
		},
		title():string {
			return this.$ct(`title-step-${this.step}`).toString();
		},
		backIcon():string{
			if (this.step == 1) {
				return "ban";
			}
			return "arrow-left";
		},
		nextIcon():string{
			if (this.step == 5){
				return "save";
			}
			return "arrow-right";
		}
	},
	methods: {
		backClicked() {
			if (this.step == 1) {
				this.close();
				return;
			}
			this.step--;
		},
		async nextClicked() {
			if (this.step == 5) {
				await this.save();
				this.close();
				return;
			}
			this.step++;
		},
		close() {
			this.state.saveModalOpen = false;
		},
		async save() {
			await this.state.save();
			this.close();
		}
	},
	components: {
		AppFreqeuncySettingEdit,
		AppPreviewDates,
		AppFinish,
		AppMailSettings,
		AppFrequencySettingsEditSelectFrequencyType
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
